import { Components } from "@thisgorilla/primate-ds";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { actions, useAppDispatch, useAppSelector } from "../../../../redux";
import { ROUTES } from "../../../../utills/routes";
import { FlexRow } from "../../../Common/Styles";
import Manage from "./manage";
import ToolbarForEditor from "./toolbarForEditor";
import { API_CALLS } from "../../../../API/api_calls";
import { ArticleProps } from "../../../../redux/slices/article/Article";

const Toolbar = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isArticleFullScreen } = useAppSelector((state) => state.common);
  const { post_id, title_content, cover_image } = useAppSelector(
    (state) => state.article.draftArticle
  );

  return (
    <>
      {isArticleFullScreen && (
        <DittoLogo
          src="/images/header/dittoLogo.svg"
          alt="Ditto"
          onClick={() => navigate(ROUTES.home)}
        />
      )}
      <Container $isFullScreen={isArticleFullScreen}>
        <FlexRow $gapInPx={0}>
          <ToolbarForEditor />
          <RightContainer>
            <Manage />
            <Components.Button
              size="Medium"
              kind="Primary"
              color="Primary"
              disabled={
                (title_content.content_data as ArticleProps.TextContentData)
                  .Blueprint.length === 0 ||
                (
                  cover_image.content_data as ArticleProps.ImageContentData[]
                )?.[0].size === 0
              }
              label="Post"
              onClick={() => {
                API_CALLS.ARTICLE.publishArticleDraft(post_id);
              }}
            />
            <Components.Tooltip
              type="label"
              label="Expand"
              position={isArticleFullScreen ? "bottom" : "top"}
            >
              <Components.IconButton
                size="Small"
                kind="Tertiary"
                disabled={false}
                onClick={() => {
                  dispatch(
                    actions.common.setIsArticleFullScreen(!isArticleFullScreen)
                  );
                }}
                iconType={isArticleFullScreen ? "Minimize2" : "Maximize2"}
              />
            </Components.Tooltip>
          </RightContainer>
        </FlexRow>
      </Container>
    </>
  );
};

export default Toolbar;

const RightContainer = styled(FlexRow)`
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  align-items: center;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
  padding: ${({ theme }) => theme.spacing["spacing-none"].value}
    ${({ theme }) => theme.spacing["spacing-6"].value}rem
    ${({ theme }) => theme.spacing["spacing-none"].value}
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  border-left: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  border-radius: ${({ theme }) => theme.radius["radius-none"].value}
    ${({ theme }) => theme.radius["radius-xs"].value}rem
    ${({ theme }) => theme.radius["radius-xs"].value}rem
    ${({ theme }) => theme.radius["radius-none"].value};
`;

const Container = styled.div<{ $isFullScreen: boolean }>`
  position: ${({ $isFullScreen }) => ($isFullScreen ? "fixed" : "sticky")};
  height: ${({ $isFullScreen, theme }) =>
    $isFullScreen && theme.spacing["spacing-18"].value}rem;
  top: ${({ $isFullScreen, theme }) =>
    $isFullScreen
      ? theme.spacing["spacing-none"].value
      : theme.spacing["spacing-18"].value}rem;
  z-index: ${({ $isFullScreen }) => ($isFullScreen ? 5 : 2)};
  left: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
  padding: ${({ theme, $isFullScreen }) =>
      theme.spacing[$isFullScreen ? "spacing-2" : "spacing-4"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
  width: 100%;
  display: flex;
  justify-content: center;
  box-shadow: ${({ theme, $isFullScreen }) =>
    $isFullScreen && theme.boxShadows["box-shadow-m"]};
`;
const DittoLogo = styled.img`
  height: ${({ theme }) => theme.spacing["spacing-10"].value}rem;
  position: fixed;
  top: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  z-index: 6;
  left: ${({ theme }) => theme.spacing["spacing-13"].value}rem;
  cursor: pointer;
`;
